export default {
  ERROR: 'Send error',
  ADD_INFO: 'Send info',
  REMOVE_INFO: "Remove info",

  // Sites
  ADD_SITE: 'Add a site',
  ADDED_SITE: 'Added a site',
  GET_SITES: 'Get sites',
  SET_SITES: 'Set sites',
  GET_SITE_USER: 'Get site user',
  SET_SITE_USER: 'Set site user',
  SET_CURRENT_SITE: 'Set the selected site',
  DELETE_SITE: 'Delete site',
  REMOVE_SITE: 'Remove site',
  EDIT_SITE: 'Edit site',
  EDITED_SITE: 'Edited site',
  EDIT_SITE_LABELS: 'Edit site labels',
  EDITED_SITE_LABELS: 'Edited site labels',

  // Areas
  ADD_AREA: 'Add an area',
  ADDED_AREA: 'Added an area',
  EXPAND_AREA: 'Expand an area',
  EXPANDED_AREA: 'Expanded an area',
  GET_AREAS: 'Get areas',
  SET_AREAS: 'Set areas',
  SET_CURRENT_AREA: 'Set the selected area',
  DELETE_AREA: 'Delete area',
  REMOVE_AREA: 'Remove area',
  EDIT_AREA: 'Edit area',
  EDITED_AREA: 'Edited area',
  EDIT_AREA_LOAD: 'Edit area load',
  EDIT_AREA_READY: 'Edit area ready',

  // Zones
  ADD_ZONE: 'Add a zone',
  ADDED_ZONE: 'Added a zone',
  GET_ZONES: 'Get zones',
  SET_ZONES: 'Set zones',
  GET_ZONES_BY_SITE: 'Get zones by site',
  SET_ZONES_BY_SITE: 'Set zones by site',
  DELETE_ZONE: 'Delete zone',
  REMOVE_ZONE: 'Remove zone',
  EDIT_ZONE: 'Edit zone',
  EDITED_ZONE: 'Edited zone',

  // Locations
  ADD_LOCATION: 'Add a location',
  ADDED_LOCATION: 'Added a location',
  EDIT_LOCATION: 'Edit a location',
  EDITED_LOCATION: 'Edited a location',
  DELETE_LOCATION: 'Delete location',
  REMOVE_LOCATION: 'Remove location',
  SET_CURRENT_LOCATION: 'Set current location',
  GET_LOCATIONS: 'Get locations',
  SET_LOCATIONS: 'Set locations',
  GET_LOCATIONS_BY_SITE: 'Get locations by site',
  SET_LOCATIONS_BY_SITE: 'Set locations by site',
  GET_LOCATIONS_GEO_JSON: 'Get locations geo json',
  SET_LOCATIONS_GEO_JSON: 'Set locations geo json',

  // Categories
  GET_CATEGORIES: 'Get categories',
  SET_CATEGORIES: 'Set categories',
  SET_CURRENT_CATEGORY: 'Set current category',
  ADD_CATEGORY: 'Add category',
  ADDED_CATEGORY: 'Added category',
  EDIT_CATEGORY: 'Edit category',
  EDITED_CATEGORY: 'Edited category',
  DELETE_CATEGORY: 'Delete category',
  REMOVE_CATEGORY: 'Remove category',
  FILTER_CATEGORY: 'Filter category',

  // Groups
  GET_GROUPS: 'Get groups',
  SET_GROUPS: 'Set groups',
  ADD_GROUP: 'Add group',
  ADDED_GROUP: 'Added group',
  SET_CURRENT_GROUP: 'Set current group',
  EDIT_GROUP: 'Edit group',
  EDITED_GROUP: 'Edited group',
  DELETE_GROUP: 'Delete group',
  REMOVE_GROUP: 'Remove group',
  FILTER_GROUP: 'Filter group',

  // Tags
  ADD_TAG: 'Add tag',
  ADDED_TAG: 'Added tag',
  EDIT_TAG: 'Edit a tag',
  EDITED_TAG: 'Edited a tag',
  GET_TAGS: 'Get tags',
  SET_TAGS: 'Set tags',
  CLEAR_TAGS: 'Clear tags',
  GET_TAGS_BY_SITE: 'Get list view tags',
  SET_LIST_VIEW_TAGS: 'Set list view tags',
  SELECT_TAG: 'Select a tag',
  EXPAND_COLLAPSE_TAG: 'Expand/collapse tag',
  SET_CURRENT_TAG: 'Set the selected tag',
  GET_FILTERS: 'Get filters',
  SET_FILTERS: 'Set filters',
  ADD_FILTER: 'Add filter',
  REMOVE_FILTER: 'Remove filter',
  CLEAR_FILTERS: 'Clear filters',
  DELETE_TAG: 'Delete tag',
  REMOVE_TAG: 'Remove tag',
  STREAM_TAGS: 'Get tags info on stream',
  CLOSE_STREAM_TAGS: 'Stop Stream Tags',
  UPDATE_TAG: 'Update tag info from stream',
  UPDATE_TAGS_TIME: 'Update tags time',
  GET_HISTORY: 'Get tag history',
  SET_HISTORY: 'Set tag history',
  CSV_HISTORY: 'Download tag history',
  BULK_UPLOAD: 'Perform a bulk upload',
  BULK_UPLOAD_FINISHED: 'Bulk upload has finished',
  BULK_UPLOAD_CLEAR: 'Clear bulk upload results',
  EXPORT_TAG_LIST: 'Export tag list',
  EXPORTED_TAG_LIST: 'exported tag list',
  SET_SORTING: 'Set Sorting',
  // Workflows
  GET_WORKFLOWS: 'Get workflows',
  SET_WORKFLOWS: 'Set workflows',
  ADD_WORKFLOW: 'Add workflow',
  ADDED_WORKFLOW: 'Added workflow',
  GET_WORKFLOW: 'Get workflow',
  SET_CURRENT_WORKFLOW: 'Set current workflow',
  EDIT_WORKFLOW: 'Edit workflow',
  EDITED_WORKFLOW: 'Edited workflow',
  DELETE_WORKFLOW: 'Delete workflow',
  REMOVE_WORKFLOW: 'Remove workflow',

  // Triggers
  GET_TRIGGERS: 'Get triggers',
  SET_TRIGGERS: 'Set triggers',
  ADD_TRIGGER: 'Add trigger',
  ADDED_TRIGGER: 'Added trigger',
  SET_CURRENT_TRIGGER: 'Set current trigger',
  EDIT_TRIGGER: 'Edit trigger',
  EDITED_TRIGGER: 'Edited trigger',
  DELETE_TRIGGER: 'Delete trigger',
  REMOVE_TRIGGER: 'Remove trigger',

  // Actions
  GET_ACTIONS: 'Get actions',
  SET_ACTIONS: 'Set actions',
  ADD_ACTION: 'Add action',
  ADDED_ACTION: 'Added action',
  SET_CURRENT_ACTION: 'Set current action',
  EDIT_ACTION: 'Edit action',
  EDITED_ACTION: 'Edited action',
  DELETE_ACTION: 'Delete action',
  REMOVE_ACTION: 'Remove action',

  // Auth
  LOGIN_ERROR: 'Error during login',
  LOGOUT_ERROR: 'Error during logout',
  LOG_IN: 'Perform login',
  LOG_OUT: 'Perform logout',
  LOGGED_IN: 'Login completed',
  LOGGED_OUT: 'Logout completed',
  READ_TOKEN: 'Read token from local storage',
  TOKEN_REFRESHED: 'Token has been refreshed',
  READ_TOKEN_ERROR: 'Error on read token',
  CREATE_ACCOUNT: 'Create account',
  CREATED_ACCOUNT: 'Account created',
  FORGOT_PASSWORD: 'forgot-password',
  FORGOT_PASSWORD_COMPLETED: 'forgot-password-completed',
  RESET_PASSWORD: 'reset-password',
  RESET_PASSWORD_COMPLETED: 'reset-password-completed',
  VERIFY_PASSWORD_TOKEN: 'verify-password-token',
  VERIFY_PASSWORD_TOKEN_COMPLETED: 'verify-password-token-completed',
  RESEND_VERIFY: 'resend-verify', //map string to "constant" you know in case we change the string cause..... yea...
  RESEND_VERIFY_COMPLETED: 'resend-verify-completed',
  RESEND_VERIFY_HIDE_MODAL: 'resend-verify-modal-hide',
  CHECK_SSO: 'check-sso',
  CHECKED_SSO: 'checked-sso',
  RESET_LOGIN: 'reset-login',

  // Users
  ADD_USER: 'Add user',
  ADDED_USER: 'Added user',
  GET_USER: 'Get user',
  SET_USER: 'Set user',
  EDIT_USER: 'Edit user',
  EDITED_SITE_USER: 'Edited site user',
  DELETE_SITE_USER: 'Delete Site user',
  REMOVE_SITE_USER_SUCCESS: 'Remove Site user ui',
  VIEW_LINK: 'View invite link',
  LINK_VIEWED: 'Link Viewed',
  CLEAR_INVITE_LINK: 'Clear invite link',
  RESEND_TOKEN: 'Resend Token',

  //Status
  GET_RP_DETAIL: 'Get Location Beacon Detail',
  SET_RP_DETAIL: 'Set Location Beacon Detail',
  GET_AP_DETAIL: 'Get Access Point Detail',
  SET_AP_DETAIL: 'Set Access Point Detail',
  GET_GATEWAY_DETAIL: 'Get Gateway Detail',
  SET_GATEWAY_DETAIL: 'Set Gateway Detail',
  RESET_STATUS_DETAIL: 'Reset Status Details',
  DELETE_SITE_AP: 'Delete Site AP',
  DELETE_SITE_GATEWAY: 'Delete Site Gateways',
  DELETE_SITE_AP_SUCCESS: 'Remove Site Ap Ui',
  DELETE_SITE_GATEWAY_SUCCESS: 'Remove Site Gateway Ui',
  GET_STATUS_SUMMARY: 'Get Status Summary',
  SET_STATUS_SUMMARY: 'Set Status Summary',

  //ERROR HANDLING
  UPDATE_ERROR_MESSAGE: 'Update Error message', // Action type for error banner

  //Zenoss Error reporting
  SEND_ERROR_REPORT:'Sending error to zenoss',
  REPORT_SENT_ZENOSS:'Report sent to zenoss',
  
  //Organizations
  GET_ORGS: 'Get organizations',
  SET_ORGS: 'Set organizations',
  SET_ORG: 'sorg',
  GET_ORG_SITES: 'Get sites by organization id',
  SET_ORG_USER_ROLE: 'Set organization user role',
  GET_ORG_USER_ROLE: 'Get organization user role'
};



// WEBPACK FOOTER //
// ./src/reducers/actionTypes.js